import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import MeetingID from '@/App/Booking/Meeting/Entity/MeetingID'
import AttendanceID from '@/App/Booking/Attendance/Entity/AttendanceID'
import {
    AttendanceStateEnum,
    AttendanceStateEnumData,
    type AttendanceRawData,
    type AttendanceStateEnumDataEntry,
} from '@/Shared/AutoGenerated/Main'
import ReservationID from '@/App/Booking/Reservation/Entity/ReservationID'

export default class Attendance {
    constructor(
        public readonly id: AttendanceID,
        public readonly reservationId: ReservationID,
        public readonly meetingId: MeetingID,
        public readonly state: AttendanceStateEnum,

        //Computed
        public readonly cannotCancel: boolean,
    ) {
        ensureNoUndefinedProperties(this)
    }

    shouldDisableNoShowToggleAction(): boolean {
        return (
            this.state === AttendanceStateEnum.Scheduled ||
            this.state === AttendanceStateEnum.Canceled
        )
    }

    isNoShow(): boolean {
        return this.state === AttendanceStateEnum.NoShow
    }

    getNoShowToggleActionLabel(): 'Mark as No-Show' | 'Revert to Completed' {
        if (this.isNoShow()) {
            return 'Revert to Completed'
        }

        return 'Mark as No-Show'
    }

    getNoShowToggleActionIconName(): 'user-check' | 'user-xmark' {
        if (this.isNoShow()) {
            return 'user-check'
        }

        return 'user-xmark'
    }

    getSchedulingStateDataEntry(): AttendanceStateEnumDataEntry {
        return AttendanceStateEnumData[this.state]
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(entityData: AttendanceRawData): Attendance {
        return new Attendance(
            new AttendanceID(entityData.id),
            new ReservationID(entityData.reservationId),
            new MeetingID(entityData.meetingId),
            entityData.state,
            entityData.cannotCancel,
        )
    }

    static hydrateMultiple(entitiesData: AttendanceRawData[]): Attendance[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
